import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSave, FaTimes, FaSearch, FaEye } from 'react-icons/fa';
import './Items.css';
import { MdLibraryAdd } from "react-icons/md";
import { FaBars } from 'react-icons/fa';



// Fake data functions (replace with actual API calls later)
const fetchItems = () => {
  return [
    {
      ItemID: 1,
      Title: 'Introduction to React',
      Author: 'John Doe',
      ISBN: '1234567890123',
      Publisher: 'Tech Publishers',
      PublicationDate: '2023-09-01',
      Language: 'English',
      Edition: '1st',
      VendorID: 1,
      VendorPrice: 19.99,
      VendorShippingPadding: 2.00,
      TotalVendorCost: 21.99,
      CategoryID: 1,
      StockQuantity: 100,
      StockStatus: 'In Stock',
      WarehouseLocation: 'A1',
      Weight: 0.5,
      Dimensions: '8x11 inches',
      ShippingClass: 'Standard',
      HandlingTime: 2,
      Description: 'A book about React basics.',
      CoverImage: 'react.jpg',
      Format: 'Paperback',
      ReleaseDate: '2023-09-01',
      AvailabilityStatus: 'Available',
      Returnable: true,
      ReturnWindow: 30
    },
    {
      ItemID: 1,
      Title: 'Introduction to React',
      Author: 'John Doe',
      ISBN: '1234567890123',
      Publisher: 'Tech Publishers',
      PublicationDate: '2023-09-01',
      Language: 'English',
      Edition: '1st',
      VendorID: 1,
      VendorPrice: 19.99,
      VendorShippingPadding: 2.00,
      TotalVendorCost: 21.99,
      CategoryID: 1,
      StockQuantity: 100,
      StockStatus: 'In Stock',
      WarehouseLocation: 'A1',
      Weight: 0.5,
      Dimensions: '8x11 inches',
      ShippingClass: 'Standard',
      HandlingTime: 2,
      Description: 'A book about React basics.',
      CoverImage: 'react.jpg',
      Format: 'Paperback',
      ReleaseDate: '2023-09-01',
      AvailabilityStatus: 'Available',
      Returnable: true,
      ReturnWindow: 30
    },
    {
      ItemID: 1,
      Title: 'Introduction to React',
      Author: 'John Doe',
      ISBN: '1234567890123',
      Publisher: 'Tech Publishers',
      PublicationDate: '2023-09-01',
      Language: 'English',
      Edition: '1st',
      VendorID: 1,
      VendorPrice: 19.99,
      VendorShippingPadding: 2.00,
      TotalVendorCost: 21.99,
      CategoryID: 1,
      StockQuantity: 100,
      StockStatus: 'In Stock',
      WarehouseLocation: 'A1',
      Weight: 0.5,
      Dimensions: '8x11 inches',
      ShippingClass: 'Standard',
      HandlingTime: 2,
      Description: 'A book about React basics.',
      CoverImage: 'react.jpg',
      Format: 'Paperback',
      ReleaseDate: '2023-09-01',
      AvailabilityStatus: 'Available',
      Returnable: true,
      ReturnWindow: 30
    },
    {
      ItemID: 1,
      Title: 'Introduction to React',
      Author: 'John Doe',
      ISBN: '1234567890123',
      Publisher: 'Tech Publishers',
      PublicationDate: '2023-09-01',
      Language: 'English',
      Edition: '1st',
      VendorID: 1,
      VendorPrice: 19.99,
      VendorShippingPadding: 2.00,
      TotalVendorCost: 21.99,
      CategoryID: 1,
      StockQuantity: 100,
      StockStatus: 'In Stock',
      WarehouseLocation: 'A1',
      Weight: 0.5,
      Dimensions: '8x11 inches',
      ShippingClass: 'Standard',
      HandlingTime: 2,
      Description: 'A book about React basics.',
      CoverImage: 'react.jpg',
      Format: 'Paperback',
      ReleaseDate: '2023-09-01',
      AvailabilityStatus: 'Available',
      Returnable: true,
      ReturnWindow: 30
    },
    {
      ItemID: 1,
      Title: 'Introduction to React',
      Author: 'John Doe',
      ISBN: '1234567890123',
      Publisher: 'Tech Publishers',
      PublicationDate: '2023-09-01',
      Language: 'English',
      Edition: '1st',
      VendorID: 1,
      VendorPrice: 19.99,
      VendorShippingPadding: 2.00,
      TotalVendorCost: 21.99,
      CategoryID: 1,
      StockQuantity: 100,
      StockStatus: 'In Stock',
      WarehouseLocation: 'A1',
      Weight: 0.5,
      Dimensions: '8x11 inches',
      ShippingClass: 'Standard',
      HandlingTime: 2,
      Description: 'A book about React basics.',
      CoverImage: 'react.jpg',
      Format: 'Paperback',
      ReleaseDate: '2023-09-01',
      AvailabilityStatus: 'Available',
      Returnable: true,
      ReturnWindow: 30
    },
    // Add more fake items here
  ];
};

const fetchVendors = () => {
  return [
    {
      VendorID: 1,
      VendorName: 'Tech Supplies Inc.',
      ContactPersonName: 'John Smith',
      PrimaryEmail: 'john@techsupplies.com',
      PhoneNumber: '555-123-4567',
      StreetAddress: '123 Tech St',
      City: 'Silicon Valley',
      State: 'CA',
      Country: 'USA',
      PostalCode: '94000',
      PaymentMethod: 'Direct Deposit',
      PayoutDetails: 'Bank of America - Acc#: XXXX1234',
      PreferredNotificationMethod: 'Email'
    },
    {
      VendorID: 2,
      VendorName: 'Books & More',
      ContactPersonName: 'Jane Doe',
      PrimaryEmail: 'jane@booksandmore.com',
      PhoneNumber: '555-987-6543',
      StreetAddress: '456 Book Ave',
      City: 'Readington',
      State: 'NY',
      Country: 'USA',
      PostalCode: '10001',
      PaymentMethod: 'PayPal',
      PayoutDetails: 'paypal@booksandmore.com',
      PreferredNotificationMethod: 'SMS'
    },
  ];
};

const fetchCategories = () => {
  return [
    {
      CategoryID: 1,
      CategoryName: 'Programming',
      Notes: 'Books related to computer programming',
      ParentCategoryID: null,
      created_at: '2023-01-01 00:00:00',
      updated_at: '2023-01-01 00:00:00'
    },
    {
      CategoryID: 2,
      CategoryName: 'Technology',
      Notes: 'General technology books',
      ParentCategoryID: null,
      created_at: '2023-01-02 00:00:00',
      updated_at: '2023-01-02 00:00:00'
    },
  ];
};

const ItemPage = () => {
  const [items, setItems] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [categories, setCategories] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [newItem, setNewItem] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [vendorFilter, setVendorFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [viewingItem, setViewingItem] = useState(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Initialize fake data for items, vendors, and categories
  useEffect(() => {
    setItems(fetchItems());
    setVendors(fetchVendors());
    setCategories(fetchCategories());
  }, []);

  // Move fetchItemDetails inside ItemPage
  const fetchItemDetails = (itemId) => {
    const item = items.find(i => i.ItemID === itemId);
    if (item) {
      const vendor = vendors.find(v => v.VendorID === item.VendorID);
      const category = categories.find(c => c.CategoryID === item.CategoryID);
      return { ...item, vendor, category };
    }
    return null;
  };

  const handleEdit = (item) => {
    const completeItem = fetchItemDetails(item.ItemID);
    setEditingItem(completeItem);
  };

  const handleDelete = (ItemID) => {
    setItems(items.filter(item => item.ItemID !== ItemID));
  };

  const handleSave = (ItemID, updatedItem) => {
    setItems(items.map(item =>
      item.ItemID === ItemID ? { ...item, ...updatedItem } : item
      ));
      setEditingItem(null);
    };



  const handleAdd = () => {
    const addedItem = {
      ItemID: Date.now(),
      ...newItem
    };
    setItems([...items, addedItem]);
    setNewItem({});
    setShowAddForm(false);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredItems = items.filter(item =>
    (vendorFilter === '' || item.VendorID.toString() === vendorFilter) &&
    (categoryFilter === '' || item.CategoryID.toString() === categoryFilter) &&
    Object.values(item).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const renderItemCard = (item) => (
    <div key={item.ItemID} className="item-card">
      <h3>{item.Title}</h3>
      <p><strong>Author:</strong> {item.Author}</p>
      <p><strong>Price:</strong> ${item.VendorPrice}</p>
      <div className="item-actions">
        <button onClick={() => setViewingItem(item)} className="item-view-btn"><FaEye /></button>
        <button onClick={() => handleEdit(item)} className="item-edit-btn"><FaEdit /></button>
        <button onClick={() => handleDelete(item.ItemID)} className="item-delete-btn"><FaTrash /></button>
      </div>
    </div>
  );
    const renderItemForm = (item, isEditing = false) => {
      const fieldGroups = [
        {
          title: 'General Information',
          titleClass: 'group-title',
          fields: [
            { name: 'Title', label: 'Title' },
            { name: 'Author', label: 'Author' },
            { name: 'ISBN', label: 'ISBN' },
            { name: 'Publisher', label: 'Publisher' },
            { name: 'PublicationDate', label: 'Publication Date', type: 'date' },
            { name: 'Language', label: 'Language' },
            { name: 'Edition', label: 'Edition' },
            { name: 'VendorPrice', label: 'Vendor Price' },
            { name: 'VendorShippingPadding', label: 'Vendor Shipping Padding' },
            { name: 'TotalVendorCost', label: 'Total Vendor Cost' }
          ]
        },
        {
          title: 'Stock & Shipping',
          titleClass: 'group-title',
          fields: [
            { name: 'StockQuantity', label: 'Stock Quantity' },
            { name: 'StockStatus', label: 'Stock Status' },
            { name: 'Weight', label: 'Weight (lbs)' },
            { name: 'Dimensions', label: 'Dimensions' },
            { name: 'ShippingClass', label: 'Shipping Class' },
            { name: 'HandlingTime', label: 'Handling Time' },
            { name: 'WarehouseLocation', label: 'Warehouse Location' }
          ]
        },
        {
          title: 'Other Details',
          titleClass: 'group-title',
          fields: [
            { name: 'CoverImage', label: 'Cover Image' },
            { name: 'Format', label: 'Format' },
            { name: 'ReleaseDate', label: 'Release Date', type: 'date' },
            { name: 'AvailabilityStatus', label: 'Availability Status' },
            { name: 'Returnable', label: 'Returnable', type: 'select' },
            { name: 'ReturnWindow', label: 'Return Window' },
            { name: 'Description', label: 'Description', type: 'textarea' }
          ]
        }
      ];

      const selectedVendor = isEditing ? item.vendor : vendors.find(v => v.VendorID.toString() === item.VendorID);
      const selectedCategory = isEditing ? item.category : categories.find(c => c.CategoryID.toString() === item.CategoryID);

      return (
        <div className={`item-form ${isEditing ? 'item-edit-form' : ''}`}>
          <h3>{isEditing ? 'Edit Item' : 'Add New Item'}</h3>
          <div className="item-form-groups">
            {fieldGroups.map((group, index) => (
              <div key={index} className="item-form-group">
                <h4 className={`column-title ${group.titleClass}`}>{group.title}</h4>
                {group.fields.map(field => (
                  field.name === 'Description' ? (
                    <div key={field.name} className="item-field description-field">
                      <label className="item-label">{field.label}</label>
                      <textarea
                        className="item-input description-input"
                        value={item[field.name] || ''}
                        onChange={(e) => isEditing
                          ? setEditingItem({...editingItem, [field.name]: e.target.value})
                          : setNewItem({...newItem, [field.name]: e.target.value})
                        }
                        placeholder={field.label}
                      />
                    </div>
                  ) : field.type === 'select' ? (
                    <div key={field.name} className="item-field">
                      <label className="item-label">{field.label}</label>
                      <select
                        className="item-input"
                        value={item[field.name] || ''}
                        onChange={(e) => isEditing
                          ? setEditingItem({...editingItem, [field.name]: e.target.value === 'true'})
                          : setNewItem({...newItem, [field.name]: e.target.value === 'true'})
                        }
                      >
                        <option value="false">Not Returnable</option>
                        <option value="true">Returnable</option>
                      </select>
                    </div>
                  ) : (
                    <div key={field.name} className="item-field">
                      <label className="item-label">{field.label}</label>
                      <input
                        type={field.type === 'date' ? 'date' : 'text'}
                        className="item-input"
                        value={item[field.name] || ''}
                        onChange={(e) => isEditing 
                          ? setEditingItem({...editingItem, [field.name]: e.target.value})
                          : setNewItem({...newItem, [field.name]: e.target.value})
                        }
                        placeholder={field.label}
                      />
                    </div>
                  )
                ))}
              </div>
            ))}
            <div className="item-form-group">
              <h4 className="column-title group-title">Vendor Information</h4>
              <div className="item-field">
                <label className="item-label">Vendor</label>
                <select
                  className="item-input"
                  value={item.VendorID || ''}
                  onChange={(e) => isEditing
                    ? setEditingItem({...editingItem, VendorID: e.target.value})
                    : setNewItem({...newItem, VendorID: e.target.value})
                  }
                >
                  <option value="">Select Vendor</option>
                  {vendors.map(vendor => (
                    <option key={vendor.VendorID} value={vendor.VendorID}>
                      {vendor.VendorName}
                    </option>
                  ))}
                </select>
              </div>
              {selectedVendor && (
                <div className="vendor-details">
                  <p><strong>Contact:</strong> {selectedVendor.ContactPersonName}</p>
                  <p><strong>Email:</strong> {selectedVendor.PrimaryEmail}</p>
                  <p><strong>Phone:</strong> {selectedVendor.PhoneNumber}</p>
                  <p><strong>Address:</strong> {selectedVendor.StreetAddress}, {selectedVendor.City}, {selectedVendor.State}, {selectedVendor.Country} {selectedVendor.PostalCode}</p>
                  <p><strong>Payment Method:</strong> {selectedVendor.PaymentMethod}</p>
                </div>
              )}
            </div>

            <div className="item-form-group">
              <h4 className="column-title group-title">Category Information</h4>
              <div className="item-field">
                <label className="item-label">Category</label>
                <select
                  className="item-input"
                  value={item.CategoryID || ''}
                  onChange={(e) => isEditing
                    ? setEditingItem({...editingItem, CategoryID: e.target.value})
                    : setNewItem({...newItem, CategoryID: e.target.value})
                  }
                >
                  <option value="">Select Category</option>
                  {categories.map(category => (
                    <option key={category.CategoryID} value={category.CategoryID}>
                      {category.CategoryName}
                    </option>
                  ))}
                </select>
              </div>
              {selectedCategory && (
                <div className="category-details">
                  <p><strong>Notes:</strong> {selectedCategory.Notes}</p>
                  <p><strong>Created At:</strong> {selectedCategory.created_at}</p>
                  <p><strong>Updated At:</strong> {selectedCategory.updated_at}</p>
                </div>
              )}
            </div>
          </div>
          <div className="item-form-actions">
            {isEditing ? (
              <>
                <button onClick={() => handleSave(item.ItemID, editingItem)} className="item-save-btn"><FaSave /> Save</button>
                <button onClick={() => setEditingItem(null)} className="item-cancel-btn"><FaTimes /> Cancel</button>
              </>
            ) : (
              <>
                <button onClick={handleAdd} className="item-add-btn"><FaPlus /> Add Item</button>
                <button onClick={() => setShowAddForm(false)} className="item-cancel-btn"><FaTimes /> Cancel</button>
              </>
            )}
          </div>
        </div>
      );
    };
  return (
    <div> 
      <div className="item-header">
        <h2>Items</h2>
        <div className={`item-header-controls ${menuOpen ? 'open' : ''}`}>
          <div className="item-search-bar">
            <FaSearch />
            <input
              type="text"
              placeholder="Search items..."
              value={searchTerm}
              onChange={handleSearch}
            />
          </div>
          <select
            className="item-filter-dropdown"
            value={vendorFilter}
            onChange={(e) => setVendorFilter(e.target.value)}
          >
            <option value="">All Vendors</option>
            {vendors.map(vendor => (
              <option key={vendor.VendorID} value={vendor.VendorID}>
                {vendor.VendorName}
              </option>
            ))}
          </select>
          <select
            className="item-filter-dropdown"
            value={categoryFilter}
            onChange={(e) => setCategoryFilter(e.target.value)}
          >
            <option value="">All Categories</option>
            {categories.map(category => (
              <option key={category.CategoryID} value={category.CategoryID}>
                {category.CategoryName}
              </option>
            ))}
          </select>
          <button onClick={() => setShowAddForm(!showAddForm)} className="item-add-toggle-btn">
            {showAddForm ? <FaTimes /> : <MdLibraryAdd />}
          </button>
        </div>
        <button className="hamburger-menu" onClick={() => setMenuOpen(!menuOpen)}>
          <FaBars />
        </button>
      </div>  
      <div className="item-container">
        {showAddForm && (          <div className="item-add-form">
            <h3>Add New Item</h3>
            {renderItemForm(newItem)}
          </div>
        )}

        <div className="item-grid">
          {filteredItems.map(item => 
            editingItem && editingItem.ItemID === item.ItemID
              ? <div key={item.ItemID} className="item-edit-container">{renderItemForm(editingItem, true)}</div>
              : renderItemCard(item)
          )}
        </div>

        {viewingItem && (
          <div className="item-modal">
            <div className="item-modal-content">
              <h2>{viewingItem.Title}</h2>
              {Object.entries(viewingItem).map(([key, value]) => (
                <p key={key}><strong>{key}:</strong> {value}</p>
              ))}
              <button onClick={() => setViewingItem(null)} className="item-close-btn"><FaTimes /> Close</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemPage;
